export default [
  {
    label: "文本",
    type: 1,
    value: "",
    icon:'#icon-tianjiawenben',
    style: "",
    sort: "",
    name:'',
    styleOption:{
      fontSize: 'font-size: 14px;',
      fontWeight: false,
      italic: false,
      underline: false,
      lineThrough: false,
      textAlignLeft: false,
      textAlignCenter: false,
      textAlignRight: false,
      background: '',
      color: '',
      title:'',
    },
    extendOption:{
      operationIsShow: false,
      allCode: false,
      isIndexes: false,
      indexText:'',
    }
  },
  {
    label: "试题",
    type: 3,
    value: "",
    icon:'#icon-tianjiashiti',
    style: "",
    sort: "",
    name:'',
    questionContent: "",
    questionTypeId:"",
    styleOption:{},
    extendOption:{
      operationIsShow: false,
      isIndexes: false,
      allCode: false,
      indexText:'',
    }
  },
  {
    label: "图片",
    type: 7,
    value: "",
    icon:'#icon-tianjiatupian',
    isShow: false,
    style: "",
    sort: "",
    name:'',
    styleOption:{
      textDecoration: 'center',
      width: 50,
    },
    extendOption:{
      operationIsShow: false,
      isIndexes: false,
      allCode: false,
      indexText:'',
    }
  },
  {
    label: "视频",
    type: 10,
    value: "",
    icon:'#icon-tianjiashipin1',
    isShow: false,
    style: "",
    sort: "",
    name:'',
    styleOption:{
      textDecoration: 'center',
      width: 50,
    },
    extendOption:{
      operationIsShow: false,
      isIndexes: false,
      allCode: false,
      indexText:'',
    }
  },
  {
    label: "代码块",
    type: 11,
    value: "",
    icon:'#icon-tianjiadaima',
    style: "",
    sort: "",
    name:'',
    styleOption:{},
    extendOption:{
      operationIsShow: false,
      isIndexes: false,
      allCode: false,
      indexText:'',
    }
  },
  {
    label: "链接",
    type: 5,
    value: "",
    icon:'#icon-link',
    style: "",
    sort: "",
    name:'',
    styleOption:{},
    extendOption:{
      operationIsShow: false,
      isIndexes: false,
      allCode: false,
      indexText:'',
    }
  },
  {
    label: "ppt",
    type: 110,
    value: "",
    icon:'#icon-tianjiappt',
    style: "",
    sort: "",
    name:'',
    styleOption:{},
    extendOption:{
      operationIsShow: false,
      isIndexes: false,
      allCode: false,
      indexText:'',
    }
  },
]



// WEBPACK FOOTER //
// ./src/views/single_resource_course/js/option.js